import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import { useHomeContext } from "../../provider/HomeProvider";
import ParkSessionSkeleton from "components/common/Skeleton/park/ParkSessionSkeleton";
import { common } from "Data/common";

const ParkSession = () => {
  const { loading, featurePark } = useHomeContext();



  return (
    <section className="safariduring_sesons paddiinTop_add">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12}>
            <div className="title_web text-center">
              <h2>
                 {common?.PARK_SESSION?.BANNER?.TITLE_1} <br />
                {common?.PARK_SESSION?.BANNER?.TITLE_2}
              </h2>
            </div>
          </Col>
        </Row>
      </Container>

      {(Array.isArray(featurePark) && featurePark?.length > 0) ? (
        featurePark.length > 0 && (
          <Swiper
            className="safari-carousel"
            loop={true}
            spaceBetween={0}
            navigation={false}
            pagination={{ clickable: true }}
            speed={500}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              0: { slidesPerView: 1 },
              600: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
              1400: { slidesPerView: 5 },
            }}
            modules={[Navigation, Autoplay]}
          >
            {featurePark.map((park) => (
              <SwiperSlide key={park.id}>
                <div className="safari-box">
                  <Link to={`/park/${park.slug}`}>
                    <figure className="image-box">
                      <img
                        src={park.feature_image_path}
                        alt={park.title}
                        loading="lazy"
                        className="img-fluid"
                      />
                    </figure>

                    <div className="content-box">
                      <h3>{park.title}</h3>
                    </div>

                    <div className="overlay-content d-flex align-items-center justify-content-between">
                      <div className="content_o pe-2">
                        <h3>{park.title}</h3>
                        <p>{park.short_description}</p>
                      </div>
                      <div className="link">
                        <p>
                          <i className="fa-solid fa-arrow-right"></i>
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ))
        : loading ? (
          <>
            <ParkSessionSkeleton  />
          </>
        ) : (
          <p>{common?.PARK_SESSION?.NO_DATA}</p>
        )}
    </section>
  );
};

export default ParkSession;

